import { usePortaalMeldingen } from "@/lib/hooks/usePortaalMeldingen";
import { usePushHerstel } from "@/lib/hooks/usePushHerstel";

/**
 * Rendert niets; draait alleen de meldingshook naast de IdleGuard in
 * de shell, zodat geluid en titel-teller op elke route werken. Sinds
 * sessie 202610234 draait hier ook het zelfherstel van het
 * pushabonnement: de shell staat er alleen voor een ingelogde gebruiker.
 */
export function PortaalMeldingen() {
  usePortaalMeldingen();
  usePushHerstel();
  return null;
}
